let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("z9M77")).then(() => parcelRequire('fw919'));